export function base_url(uri) {
  let getUrl = window.location;
  let $uri = "";
  if (uri) {
    $uri = uri;
  }
  return getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split("/")[1] + "/" + $uri;
}

export function host_url(uri) {
  let getUrl = window.location;
  let $uri = "";
  if (uri) {
    $uri = uri;
  }
  return getUrl.protocol + "//" + getUrl.host + "/" + $uri;
}

// Show Notification
export function live_toast(json) {
  // ค่า default สำหรับ toast notification
  const icon_brand = `<svg width="36" height="36" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                            viewBox="0 0 595.3 400" style="enable-background:new 0 0 595.3 400;" xml:space="preserve">
                        <style type="text/css">
                            .st0{fill:#330166;}
                            .st1{fill:#FFFFFF;}
                        </style>
                        <g id="Layer_1">
                            <path class="st0" d="M98.9,333.3c-0.2-88-0.2-175.7-0.2-263.8c0.4-15.2,6.1-27.8,15.1-39.1C122.8,19,134,10.3,147.5,4.7
                                c5.9-2.5,12.2-3,18.8-3.4C254.3,1,342,1,430.2,1c15.1,0.5,27.8,6.1,39.1,15.1c12.4,9.8,21.6,22,26.9,37c1.7,4.9,1.9,10.1,2.3,15.5
                                c0.2,88,0.2,175.7,0.2,263.8c-0.4,15.2-6.1,27.8-15.1,39.1c-9.1,11.4-20.3,20.1-33.7,25.7c-5.9,2.5-12.2,3-18.8,3.4
                                c-88,0.2-175.7,0.2-263.8,0.2c-15.2-0.4-27.8-6.1-39.1-15.1c-11.4-9.1-20.1-20.3-25.7-33.7C99.8,346.2,99.3,339.9,98.9,333.3z"/>
                            <path class="st1" d="M435.7,108.1c-0.3,13.8,1.3,27.2-1,40.4c-3.2,18.2-17.6,32.1-36,34.4c-14.3,1.8-28.6,0.8-42.9,0.7
                                c-17.2-0.2-35.2-16-38.1-32.8c-3.1-18-3.6-36.3,0.1-54.1c3.8-17.8,15.8-28.8,33.8-31.7c15.6-2.5,31.7-2.5,47.3-0.2
                                C421.5,68.2,434.9,84.7,435.7,108.1z"/>
                            <path class="st1" d="M235.6,338.1c-11.3,0-22.2-0.3-33,0c-17.7,0.5-37.1-15.9-39.8-34.4c-2.5-16.5-2.5-33.3-0.1-49.8
                                c2.7-19.1,17.5-32.8,36.5-35c14.6-1.7,29.3-1.7,43.9-0.1c20.5,2.2,35.3,17.3,37.7,37.8c1.5,12.4,1.1,25,0.5,37.4
                                C279.8,321.2,263.1,337.2,235.6,338.1z"/>
                            <path class="st1" d="M201,143.4c3.5,5.7,8.2,8,14.5,7.7c4.5-0.2,9,0,13.5-0.1c8.2-0.1,13.8-5,14.7-13.2c0.3-2.3,0.9-3.1,3.3-3.1
                                c10.5,0.1,21,0.1,31.5,0c2.5,0,3,1,3,3.3c0.4,24.5-15.5,43.1-39.9,45.3c-14.1,1.3-28.3,1.4-42.4-0.3c-19.2-2.2-33.6-15.7-36.6-34.9
                                c-2.4-15.4-2.2-31-0.4-46.3c2.5-21.2,16.5-34.9,38.1-37.3c15.7-1.7,31.7-2.1,47.3,0.6c19.9,3.3,34.5,22,33.9,42.3
                                c-0.1,2.1-0.6,3-2.8,3c-10.7-0.1-21.3-0.1-32,0c-2.1,0-2.7-0.8-3-2.9c-1-5.8-5.6-10.2-11.5-10.7c-6.1-0.5-12.3-0.3-18.5-0.3
                                c-7.1,0.1-12.2,4-13.5,10.5C197.8,119,197.3,131.1,201,143.4z"/>
                            <path class="st1" d="M390.6,303.1c-11.8-0.1-23.2,0-34.5-0.3c-3.7-0.1-5.2,0.6-5,4.8c0.4,8.8,0,17.7,0.2,26.5
                                c0.1,3.3-0.9,4.3-4.2,4.2c-9.2-0.2-18.3-0.2-27.5,0c-3.1,0.1-3.9-0.9-3.9-4c0.1-37.3,0.1-74.6,0-111.9c0-3.2,0.7-4.3,4.1-4.3
                                c27.3,0.4,54.6,0.4,81.9,0.9c20.5,0.4,33.8,14.2,34,34.6c0.1,7,0.5,14.1-0.5,20.9c-2.4,16.1-15.8,27.5-32.6,28.4
                                C398.8,303.2,395,303.1,390.6,303.1z"/>
                            <path class="st0" d="M361.7,245.9c10.7,0,20.8,0,31,0c5.9,0,7.8,1.9,8,7.7c0.1,4.7,0.2,9.3-0.1,14c-0.2,4.8-2.8,7.4-7.6,7.4
                                c-12.8,0.1-25.7,0-38.5,0.1c-2.8,0-3.3-1-3.2-3.5c0.1-7.2,0.3-14.3,0-21.5c-0.2-3.7,1.2-4.7,4.5-4.2
                                C357.5,246.1,359.3,245.9,361.7,245.9z"/>
                        </g>
                        </svg>`;
  const _default = {
    header: `<strong class="ms-2">NOTIFICATION</strong>`,
    body: "This SOCSCI-COOP Notification",
    delay: 5000,
    margin: "5rem 1rem 1rem",
    className: "border-0 text-bg-primary",  // Default class สำหรับ "primary"
  };

  // กำหนดค่า option โดยรวมค่า default กับค่าที่ส่งเข้ามาใน json
  let option = {
    ..._default,
    ...json,
  };

  // จัดการสไตล์ตามประเภท (type) ของการแจ้งเตือน
  if (json?.type) {
    switch (json.type) {
      case "primary":
        option.className = "border-0 text-bg-primary";
        break;
      case "secondary":
        option.className = "border-0 text-bg-secondary";
        break;
      case "success":
        option.header = `<i class="bi bi-check-circle-fill text-success me-2"></i><strong>Success!</strong>`;
        option.className = "border-0 text-bg-success";
        break;
      case "danger":
        option.header = `<i class="bi bi-x-circle-fill text-danger me-2"></i><strong>Error!</strong>`;
        option.className = "border-0 text-bg-danger";
        break;
      case "warning":
        option.className = "border-0 text-bg-warning";
        break;
      case "info":
        option.header = `<i class="bi bi-info-circle-fill text-info me-2"></i><strong>Information!</strong>`;
        option.className = "border-0 text-bg-info";
        break;
      case "dark":
        option.className = "border-0 text-bg-dark";
        break;
      case "light":
        option.className = "border-0 text-bg-light";
        break;
      default:
        console.warn(`Unknown type: ${json.type}. Applying primary style as default.`);
        option.className = "border-0 text-bg-primary"; // ใช้ primary เป็นค่า default ในกรณี type ไม่ถูกต้อง
        break;
    }
  }

  // สร้าง toast และแสดงผลถ้ามีข้อความ body
  if (json.body) {
    const toast = new bs5.Toast(option);
    toast.show();
  } else {
    console.warn("Toast body is empty. Toast not displayed.");
  }
}

export function forcusElement(elementID, focus = false) {
  if (focus) {
    elementID.scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }
}

/**
 * The function `to_buddhist_year` converts a given moment to Buddhist calendar year and formats it
 * according to the specified format.
 * @param moment - The `moment` parameter is a JavaScript library that helps with parsing, validating,
 * manipulating, and formatting dates and times in JavaScript. It is commonly used for working with
 * dates and times in web applications.
 * @param format - The `format` parameter is a string that specifies the format in which you want the
 * Buddhist year to be displayed. It can contain placeholders like "YYYY" for the full year and "YY"
 * for the last two digits of the year.
 * @returns The function `to_buddhist_year` takes a moment object and a format string as input,
 * converts the moment to Buddhist calendar year, and returns the moment formatted in the specified
 * format with the Buddhist year replacing the Christian year.
 */
export function to_buddhist_year(moment, format) {
  moment.locale('th');
  var christianYear = moment.format("YYYY");
  var buddhishYear = (parseInt(christianYear) + 543).toString();
  return moment.format(format.replace("YYYY", buddhishYear).replace("YY", buddhishYear.substring(2, 4))).replace(christianYear, buddhishYear);
}

export async function fetchData(url, formData = null, method = "POST") {
  try {
    // เรียกใช้งาน fetch โดยตั้งค่า method และ body
    const response = await fetch(url, {
      method: method,
      body: formData,
      // ไม่ต้องตั้งค่า Content-Type เพราะ FormData จะกำหนด Content-Type เป็น multipart/form-data อัตโนมัติ
    });
    // แปลง response เป็น JSON
    const jsonData = await response.json();
    // เพิ่ม status, statusText และ ok ลงใน jsonData
    jsonData.ok = response.ok;
    jsonData.status = response.status;
    jsonData.statusText = response.statusText;
    return jsonData;
  } catch (error) {
    console.error("Fetch error: ", error);
    // คืนค่าในกรณีที่เกิดข้อผิดพลาด
    return { status: null, ok: false, data: null };
  }
}

/**
 * The currency_formatter function formats a number as a currency in Thai Baht with optional decimal
 * precision.
 * @param number - The `number` parameter in the `currency_formatter` function is the numerical value
 * that you want to format as a currency. It represents the amount that you want to convert into a
 * formatted currency string.
 * @param [decimal=false] - The `decimal` parameter in the `currency_formatter` function is a boolean
 * value that determines whether or not to display decimal places in the formatted currency. If
 * `decimal` is set to `true`, the function will display the currency amount with two decimal places.
 * If `decimal` is set to `
 * @returns The function `currency_formatter` returns a formatted number using the `Intl.NumberFormat`
 * constructor with the specified options. The number is formatted according to the Thai locale
 * ("th-TH") with a minimum of either 0 or 2 decimal places based on the conditions provided in the
 * function.
 */
export function currency_formatter(number, decimal = false) {
  return new Intl.NumberFormat("th-TH", { minimumFractionDigits: number % 1 == 0 && !decimal ? 0 : 2 }).format(number);
}

/**
 * The function `state_color` determines the color based on the state input in JavaScript.
 * @param state - The `state_color` function takes a `state` parameter as input and returns a color
 * based on the value of the `state`. The possible values for the `state` parameter are "PASS",
 * "APPROVE", "RETURN", "REJECT", "DELETE", and "RE-SEND
 * @returns The function `state_color` returns a color based on the input `state`. The color returned
 * depends on the value of the `state` parameter. The possible return values are "success", "warning",
 * "danger", "info", or "secondary".
 */
export function state_color(state) {
  let color = "secondary";
  if (["PASS", "APPROVE"].includes(state)) {
    color = "success";
  } else if (["RETURN"].includes(state)) {
    color = "warning";
  } else if (["REJECT", "DELETE"].includes(state)) {
    color = "danger";
  } else if (["RE-SEND"].includes(state)) {
    color = "info";
  }
  return color;
}

/**
 * The function `require_icon` adds an asterisk icon next to form field labels if the field is required
 * and not empty.
 * @param formEl - The `formEl` parameter in the `require_icon` function represents the form element to
 * which the required icons will be added based on the validation rules specified in the `fields`
 * object.
 * @param fields - The `fields` parameter in the `require_icon` function seems to be an object
 * containing field names as keys and validation information as values. Each validation information
 * object may contain validators like `notEmpty` or `callback`.
 */
export function require_icon(formEl, fields) {
  const _fv_field = fields;
  const _form = formEl;
  Object.entries(_fv_field).forEach((entry) => {
    const [field_name, valid] = entry;
    let _elem = _form.querySelector('[name="' + field_name + '"]');
    let _elem_for = _elem.type == "radio" || _elem.type == "checkbox" || _elem.classList.contains("input-array") ? _elem.id.split("_")[0] : _elem.id;
    if (_elem.id != "" && (valid.validators.notEmpty || valid.validators.callback)) {
      if (_form.querySelector('label[for="' + _elem_for + '"]>i.bi-asterisk') === null && !_elem.classList.contains("input-optional"))
        _form.querySelector('label[for="' + _elem_for + '"]')?.insertAdjacentHTML("beforeend", '<i class="bi bi-asterisk small ms-2 text-danger"></i>');
    }
  });
};


/**
* Serialize all form data into an array
* @param {HTMLFormElement} form The form to serialize
* @returns {Array} The serialized form data
*/
export function serializeArray(form) {
  // Create a new FormData object
  const formData = new FormData(form);
  // Create an array to hold the name/value pairs
  const pairs = [];
  // Add each name/value pair to the array
  for (const [name, value] of formData) {
    pairs.push({ name, value });
  }
  // Return the array
  return pairs;
}

export async function removeDatatableRow(deleteUrl, formData, datatableInstance, tableRow, liveToast = false) {
  if (!deleteUrl || !formData || !datatableInstance || !tableRow) {
    console.error("Invalid arguments provided");
    return false;
  }

  try {
    const { result, dialog } = await confirmRemoveData();

    if (result && result.toUpperCase() === "DELETE") {
      const deleteResult = await processDelete(deleteUrl, formData, datatableInstance, tableRow, liveToast, dialog);
      return deleteResult; // ส่งผลลัพธ์จาก processDelete กลับไป
    } else if (result !== null) {
      if (liveToast) func.live_toast({ body: "ข้อมูลไม่ถูกลบ", type: "danger" });
      dialog.modal("hide");
      return { success: false, message: "User canceled the deletion." }; // ผู้ใช้ยกเลิก
    }
  } catch (error) {
    console.error("Error during confirmation:", error);
    return { success: false, message: "An error occurred during confirmation.", error };
  }
}

export async function processDelete(deleteUrl, formData, datatableInstance, tableRow, liveToast, dialog) {
  try {
    const response = await func.fetchData(func.host_url(deleteUrl), formData);
    if (response?.status === 202) {
      datatableInstance.row(tableRow).remove().draw();
      if (liveToast) func.live_toast(response);
      return { success: true, message: "Data successfully deleted." }; // ส่งผลลัพธ์สำเร็จ
    } else {
      if (liveToast) func.live_toast(response);
      return { success: false, message: "Failed to delete data.", response }; // ส่งผลลัพธ์ล้มเหลว
    }
  } catch (error) {
    console.error("Error removing data:", error);
    if (liveToast) {
      func.live_toast({
        body: "เกิดข้อผิดพลาดในการลบข้อมูล",
        type: "danger",
      });
    }
    return { success: false, message: "An error occurred during deletion.", error }; // ส่งข้อผิดพลาด
  } finally {
    dialog.modal("hide");
  }
}

export function confirmRemoveData() {
  return new Promise((resolve, reject) => {
    const dialog = bootbox.prompt({
      locale: "th",
      size: "sm",
      className: 'modal-confirm modal-delete',
      title: '<i class="bi bi-exclamation-triangle me-2"></i>ยืนยันการลบ',
      centerVertical: true,
      backdrop: true,
      closeButton: false,
      message: `<span class="fw-bold">ท่านต้องการลบข้อมูล ?</span><br/>
        <span class="small text-danger"><i class="bi bi-dash"></i> การดำเนินการนี้จะไม่สามารถย้อนกลับได้</span>
        <hr>
        <div class="text-center small mb-2">พิมพ์คำว่า DELETE เพื่อลบข้อมูลนี้</div>`,
      buttons: {
        confirm: {
          label: '<i class="bi bi-trash3 me-2"></i>ยืนยันลบ',
          className: "btn-danger",
        },
      },
      swapButtonOrder: true,
      callback: (result) => {
        resolve({ result, dialog });
      },
    });
  });
}

export function confirmRemoveStudentCoopadvisor() {
  return new Promise((resolve, reject) => {
    const dialog = bootbox.confirm({
      locale: "th",
      size: "sm",
      className: 'modal-confirm modal-delete',
      title: '<i class="bi bi-exclamation-triangle me-2"></i>ยืนยันการยกเลิก',
      centerVertical: true,
      backdrop: true,
      closeButton: false,
      message: `<span class="fw-bold">ท่านต้องการยกเลิกนิเทศนิสิต ?</span><br/>
                <span class="small text-danger"><i class="bi bi-dash"></i> การดำเนินการนี้ ทำให้ข้อมูลแบบฟอร์มดังนี้หายไป (ถ้ามีการดำเนินการแล้ว)</span>
                  <ul class="small text-danger mb-0">
                    <li>Co-op-07-1</li>
                    <li>Co-op-07-2</li>
                    <li>Co-op-07-3</li>
                    <li>Co-op-10</li>
                  </ul>`,
      buttons: {
        confirm: {
          label: '<i class="bi bi-x-lg me-2"></i>ยืนยันการยกเลิก',
          className: "btn-danger",
        },
      },
      swapButtonOrder: true,
      callback: (result) => {
        resolve({ result, dialog }); // ส่งผลลัพธ์พร้อม dialog กลับไป
      },
    });
  });
}

/**
 * เปลี่ยนตัวอักษรตัวแรกของสตริงให้เป็นตัวพิมพ์ใหญ่
 *
 * @param {string} str - สตริงที่ต้องการเปลี่ยนตัวอักษรตัวแรก
 * @returns {string} - สตริงที่มีตัวอักษรตัวแรกเป็นตัวพิมพ์ใหญ่
 */
export function firstCharUpper(str) {
  if (!str) return str; // ตรวจสอบว่าถ้าเป็นค่าว่าง, null หรือ undefined ให้คืนค่าเดิมกลับไป
  return str.charAt(0).toUpperCase() + str.slice(1);
}